<app-breadcrumb [master]="'Narzędzia'" [parentName]="'Menedżer stron'" [name]="'Lista'"></app-breadcrumb>
<div class="page-list-container">
    <form (keyup.enter)="filter()" (submit)="filter()" #filtersForm="ngForm" class="page-list-filters">
      <mat-form-field class="page-list-filter">
        <mat-label>Nazwa</mat-label>
        <input matInput placeholder="Plik.pdf" name="name" [(ngModel)]="initialFilters.name">
      </mat-form-field>

      <app-datepicker
        class="page-list-filter"
        label="Data dodania od"
        placeholder="2000-01-01"
        [(ngModel)]="initialFilters.gte$createdAt" name="gte$createdAt"
      ></app-datepicker>

      <app-datepicker
        class="page-list-filter"
        label="Data dodania do"
        placeholder="2000-01-01"
        [(ngModel)]="initialFilters.lte$createdAt" name="lte$createdAt"
      ></app-datepicker>

      <mat-form-field class="page-list-filters">
        <mat-label>Użytkownik</mat-label>
        <input matInput placeholder="JanKow123" name="username" [(ngModel)]="initialFilters.username">
      </mat-form-field>
    </form>

  <div class="page-list-buttons">
    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>
    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>
  </div>


  <div fxLayout="row" fxLayoutGap="15px" style="margin-bottom: 15px">
    <button *ngIf="(userPermissions | async)?.file_manager.create" (click)="addPage()"  class="report-button" mat-raised-button color="primary">
      <mat-icon>add</mat-icon>
      <span> Dodaj  </span></button>



    <!--    <button (click)="filter()" mat-raised-button color="primary"><mat-icon>search</mat-icon> <span> Szukaj</span></button>-->
    <!--    <button (click)="resetFilters()" mat-raised-button color="warn"><mat-icon>delete</mat-icon> <span> Resetuj filtry</span></button>-->
  </div>

  <div fxLayout="column">


    <table mat-table [dataSource]="pageManager">

      <ng-container matColumnDef="fileName">
        <th mat-header-cell *matHeaderCellDef> Nazwa</th>
        <td mat-cell *matCellDef="let element">
          <a class="default-link" [routerLink]="['/serwis-plikow/strona', element.uuid]">{{ element.name}}</a>
        </td>
      </ng-container>




      <ng-container matColumnDef="cratedAt">
        <th mat-header-cell *matHeaderCellDef> Data utworzenia</th>
        <td mat-cell *matCellDef="let element">
          {{element.createdAt | date:'y-MM-dd'}}
        </td>
      </ng-container>


      <ng-container matColumnDef="createdBy">
        <th mat-header-cell *matHeaderCellDef > Użytkownik</th>
        <td mat-cell *matCellDef="let element" >
          {{element.createdBy }}
        </td>
      </ng-container>

      <ng-container matColumnDef="download">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button *ngIf="(userPermissions | async).file_manager.admin_root ||( element.userId === profile.userId  && (userPermissions | async).file_manager.delete)" [disabled]="!(userPermissions | async).file_manager.admin_root && element.userId !== profile.userId"  (click)="deletePage(element.uuid)"  mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>
<!--          <button  [disabled]="!(userPermissions | async).file_manager.admin_root " (click)="deletePage(element.uuid)"  mat-icon-button color="warn"><mat-icon>delete</mat-icon></button>-->
<!--          <button  [disabled]="!(userPermissions | async).file_manager.read " (click)="editCatalog(element)"  mat-icon-button ><mat-icon>edit</mat-icon></button>-->


        </td>
      </ng-container>




      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 20, 50,]" [length]="totalData"></mat-paginator>
  </div>
</div>
